import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import { Luggage } from 'lucide-react';

export function EmptyState() {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/30 p-12 text-center max-w-lg mx-auto"
    >
      <div className="w-20 h-20 bg-gradient-to-br from-ocean to-sky rounded-full flex items-center justify-center mb-6 mx-auto shadow-lg">
        <Luggage className="w-10 h-10 text-white" />
      </div>
      <h2 className="font-serif text-2xl text-ocean mb-2">No trips yet</h2>
      <p className="text-charcoal/60 mb-6">
        Start planning your next adventure. Our AI will create a personalized
        itinerary based on your preferences.
      </p>
      <Button
        className="bg-gold hover:bg-gold-light text-ocean font-semibold px-8 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
        onClick={() => navigate('/new-trip')}
        data-testid="empty-state-cta"
      >
        Plan Your First Trip
      </Button>
    </motion.div>
  );
}
